// import Api from "../utils/api";
// import {FETCH_LANDING} from "../types";

export function fetchLandings(object) {
    return function (dispatch) {


    }
}